import { render, staticRenderFns } from "./FolderOutline.vue?vue&type=template&id=82c72fa8&"
import script from "./FolderOutline.vue?vue&type=script&lang=js&"
export * from "./FolderOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports